import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.50994 3.53013C6.7107 3.34053 6.71974 3.02407 6.53013 2.82332C6.34053 2.62256 6.02407 2.61351 5.82331 2.80312L2.82331 5.63645C2.7233 5.73091 2.66663 5.8624 2.66663 5.99996C2.66663 6.13753 2.7233 6.26901 2.82331 6.36347L5.82331 9.1968C6.02407 9.38641 6.34053 9.37737 6.53013 9.17661C6.71974 8.97585 6.7107 8.65939 6.50994 8.46979L4.42424 6.49996H10.1666C11.3632 6.49996 12.3333 7.47004 12.3333 8.66663V12.8333C12.3333 13.1094 12.5572 13.3333 12.8333 13.3333C13.1094 13.3333 13.3333 13.1094 13.3333 12.8333V8.66663C13.3333 6.91775 11.9155 5.49996 10.1666 5.49996H4.42424L6.50994 3.53013Z"
      fill="currentColor"
    />
  </SvgIcon>
));
